<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content" :class="show ? 'content1' : ''">
    <Header :tabIndex="tabIndex"></Header>
    <div class="header">
      <div class="item">
        <div class="left">
          <el-image
            class="img"
            fit="cover"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_1.png"
          ></el-image>
        </div>
        <div class="right">
          <div class="right_head">
            <div class="title">二白 Mini 机器人</div>
            <div class="texts">
              <div class="text">很会逗你的小萌宠</div>
              <div class="shu"></div>
              <div class="text">会说话的情绪搭子</div>
            </div>
            <div class="btn" @click="show = true">立即订购</div>
          </div>
          <div class="right_bottom">
            <div class="infos">
              <el-image
                class="img"
                fit="cover"
                src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_2.png"
              ></el-image>
              <div class="text">标准款服饰</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="nav_item nav_item1">
        <div class="nav_item_title">基础功能</div>
        <div class="nav_info">
          <el-image
            class="img"
            fit="cover"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_3.png"
          ></el-image>
          <div class="list">
            <div
              class="item"
              :class="'item' + index"
              v-for="(item, index) in nav_info"
              :key="index"
            >
              <el-image class="item_bg" fit="cover" :src="item.img"></el-image>
              <div class="infos">
                <div class="title">
                  <div class="text">{{ item.text }}</div>
                  <el-image
                    v-if="item.state == 1"
                    class="img1"
                    fit="cover"
                    src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_dsx.png"
                  ></el-image>
                </div>
                <div class="text1">{{ item.text1 }}</div>
                <div class="text2" v-if="item.text2 != ''">
                  {{ item.text2 }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav_item nav_item2">
        <div class="nav_item_title">情绪与互动功能</div>
        <div class="tags">
          <div
            class="tag_item"
            @click="changeTag(index)"
            v-for="(item, index) in tags"
            :key="index"
          >
            <div class="item" :class="item.isChecked ? 'item1' : ''">
              <el-image
                v-if="!item.onlne"
                class="img"
                fit="cover"
                src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_dsx2.png"
              ></el-image>
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
        <div class="infos">
          <div class="left">
            <el-image
              class="img"
              fit="cover"
              :src="nav_info1[tagIndex].img"
            ></el-image>
          </div>
          <div class="right">
            <div class="text">{{ nav_info1[tagIndex].text }}</div>
            <div class="text1">{{ nav_info1[tagIndex].text1 }}</div>
          </div>
        </div>
      </div>
      <div class="nav_item nav_item3">
        <div class="item3_info">
          <div class="item_head">成长与个性化功能</div>
          <div class="item_left">
            <div class="titles">
              <div class="title">{{ slides[currentIndex].title }}</div>
              <img
                class="img"
                src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_dsx.png"
                alt=""
              />
            </div>
            <div class="texts">
              <div class="text">{{ slides[currentIndex].text }}</div>
            </div>
          </div>
          <div class="item_right">
            <swiper :options="swiperOptions" ref="mySwiper">
              <!-- 轮播项 -->
              <swiper-slide v-for="(slide, index) in slides" :key="index">
                <div class="slide_content">
                  <div class="image_section">
                    <img class="img1" :src="slide.img" alt="轮播图" />
                  </div>
                </div>
              </swiper-slide>
              <!-- 分页器 -->
              <!-- <div class="swiper-pagination" slot="pagination"></div> -->
              <!-- 导航按钮 -->
              <!-- <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
            </swiper>
          </div>
        </div>
      </div>
      <div class="nav_item nav_item4">
        <div class="infos">
          <div class="info_left">
            <el-image
              class="img"
              fit="cover"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_tu10.png"
            ></el-image>
          </div>
          <div class="info_right">
            <div class="title">远处陪伴功能</div>
            <div class="item">
              <div class="text">传话功能</div>
              <div class="text1">
                情感化措辞重构技术，将原始信息智能润色为温
              </div>
              <div class="text1">暖表达，适用于亲子/情侣场景</div>
            </div>
            <div class="item">
              <div class="text">生成式提醒</div>
              <div class="text1">
                通过对话分析，智能创建提醒事项（如会议、闹
              </div>
              <div class="text1">钟）</div>
            </div>
          </div>
          <div class="info_footer">
            <!-- <el-image
              class="img"
              fit="cover"
              src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/bottom_bg.png"
            ></el-image> -->
            <div class="footer_info">
              <div class="info_item">
                <div class="info_head">
                  <div class="text">线上聊天陪伴</div>
                  <!-- <el-image
                    class="img1"
                    fit="cover"
                    src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_dsx.png"
                  ></el-image> -->
                </div>
                <div class="texts">
                  <div class="text">可通过微信/小程序，和二白聊天，支</div>
                  <div class="text">持单聊、群聊，给其他好友转达信息</div>
                </div>
              </div>
              <div class="shu"></div>
              <div class="info_item">
                <div class="info_head">
                  <div class="text">AI家庭监控</div>
                  <el-image
                    class="img1"
                    fit="cover"
                    src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_dsx.png"
                  ></el-image>
                </div>
                <div class="texts">
                  <div class="text">远程触发拍摄家中情况，并生成语音/</div>
                  <div class="text">小视频简报（如查看宠物）</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav_item nav_item5">
        <div class="nav_item_title">二白Mini成长路径</div>
        <div class="nav_item_title1">
          每一台二白Mini，从“刚见面”开始，都会随着你的陪伴
        </div>
        <div class="line_infos">
          <div
            class="line_infos_item"
            v-for="(item, index) in nav_info2"
            :key="index"
          >
            <div class="head_img">
              <el-image class="img" fit="cover" :src="item.img"></el-image>
            </div>
            <div class="foot">
              <el-image class="bg" :src="item.bg"></el-image>
              <div class="texts">
                <div class="text">{{ item.text }}</div>
                <div class="text1">{{ item.text1 }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="info_foot_text">
          你不是在用它，你是在“养”它，它在成为你的专属二白
        </div>
      </div>
      <div class="nav_item nav_item6"></div>
      <div class="nav_item nav_item7">
        <el-image
          class="img"
          fit="cover"
          src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/specifications.png"
        ></el-image>
      </div>
      <div class="nav_item nav_item7">
        <el-image
          class="img"
          fit="cover"
          src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/difference.png"
        ></el-image>
      </div>
      <div class="nav_item nav_item8"></div>
    </div>
    <div class="page_footer">
      <el-image
        class="img"
        fit="cover"
        src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/instructions.png"
      ></el-image>
    </div>
    <Footer></Footer>
    <div class="show" v-if="show">
      <el-image
        @click="show = false"
        class="close"
        src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/close.png"
      ></el-image>
      <div class="show_head">
        <div class="show_title">立即前往订购~</div>
      </div>
      <div class="show_nav">
        <el-image
          class="ercode"
          src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/homePage.png"
        ></el-image>
        <div class="texts">
          <div class="text">微信扫码，跳转至小程序</div>
          <div class="text">“二白机器人”</div>
        </div>
      </div>
    </div>
    <div class="shade" v-if="show"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import "swiper/css/swiper.css"

export default {
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      tabIndex: 2,
      nav_info: [
        {
          text: "智能主动社交",
          text1:
            "搭载语境感知算法，主动发起聊天、陪你说废话，是你生活中永远在线的社交搭子。",
          text2: "",
          state: 0,
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_g_1.png",
        },
        {
          text: "全域智控中枢",
          text1:
            "支持100+品类智能家居控制，智能识别起床、回家等生活场景，自动执行多设备控制。",
          text2: "生态：米家（已接入） / 天猫 / 华为 /苹果（拓展中）",
          state: 1,
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_g_2.png",
        },
        {
          text: "心情电台",
          text1: "通过情绪识别技术，实时解析用户情绪状态，自动生成动态歌单。",
          text2: "音乐生态：网易云音乐 / QQ音乐",
          state: 0,
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_g_3.png",
        },
        {
          text: "生成式提醒",
          text1: "通过对话分析，智能创建提醒事项（如会议、闹钟）",
          text2: "",
          state: 0,
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_g_4.png",
        },
        {
          text: "双模网络引擎",
          text1:
            "支持Wi-Fi/移动网络双通道智能切换，出厂即联网，可开启热点功能，为其他设备提供网络支持。",
          text2: "",
          state: 0,
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_g_5.png",
        },
      ],
      nav_info2: [
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_cz1.png",
          text: "第一次对话",
          text1: "学会叫你喜欢的名字",
          bg: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_cz1_bg.png",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_cz2.png",
          text: "第7天",
          text1: "掌握你常说的口头禅",
          bg: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_cz2_bg.png",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_cz3.png",
          text: "第14天",
          text1: "开始学你的语气和风格说话",
          bg: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_cz3_bg.png",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_cz4.png",
          text: "第30天",
          text1: "拥有只属于你们之间的",
          bg: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_cz4_bg.png",
        },
      ],
      tags: [
        {
          text: "亲近感应系统",
          isChecked: true,
          onlne: true,
        },
        {
          text: "实时情绪回应",
          isChecked: false,
          onlne: true,
        },
        {
          text: "情绪补给模式",
          isChecked: false,
          onlne: true,
        },
        {
          text: "习惯养成助手",
          isChecked: false,
          onlne: true,
        },
        {
          text: "情感波动图谱",
          isChecked: false,
          onlne: true,
        },
        {
          text: "数字形象顾问",
          isChecked: false,
          onlne: false,
        },
      ],
      nav_info1: [
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/info_img.png",
          text: "亲近感应系统",
          text1: "感知到你的存在，能主动亲近，求关注，提\n供恰到好处的陪伴",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/info_img1.png",
          text: "实时情绪回应",
          text1:
            "基于情绪识别算法，听懂你的不开心、疲\n惫、委屈，第一时间送上情绪回应和安慰",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/info_img2.png",
          text: "情绪补给模式",
          text1: "基于积极心理学模型，触发鼓励对话/解压\n音效实现情绪补给",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/info_img3.png",
          text: "习惯养成助手",
          text1: "制定渐进式习惯养成计划，\n陪你完成每一个里程碑",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/info_img4.png",
          text: "情感波动图谱",
          text1: "记录你的情绪变化，\n生成可视化情绪状态周报",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/info_img5.png",
          text: "数字形象顾问",
          text1: "搭建你的数字衣橱，\n结合天气/日程/风格偏好生成智能穿搭建议",
        },
      ],
      currentIndex: 0,
      swiperOptions: {
        slidesPerView: 2, // 每次显示一张幻灯片
        spaceBetween: 40, // 幻灯片间距
        // centeredSlides: true, // 居中显示
        loop: true, // 循环播放
        grabCursor: true, // 抓手光标
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 4000, // 4秒自动切换
          disableOnInteraction: false,
        },
        speed: 800, // 切换速度
        effect: "slide", // 滑动效果
      },
      slides: [
        {
          title: "机器人私塾",
          state: 0,
          text: "教它新知识、新认知与新观点，构建你和它的专属知识图谱",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_tu7.png",
        },
        {
          title: "独特语言风格",
          state: 1,
          text: "教它新知识、新认知与新观点，构建你和它的专属知识图谱",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_tu8.png",
        },
        {
          title: "OTA功能升级",
          state: 1,
          text: "教它新知识、新认知与新观点，构建你和它的专属知识图谱",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/mini_tu9.png",
        },
      ],
      tagIndex: 0,
      show: false,
    }
  },
  mounted() {},
  methods: {
    changeTag(e) {
      if (e != this.tagIndex) {
        this.tags[this.tagIndex].isChecked = false
        this.tagIndex = e
        this.tags[this.tagIndex].isChecked = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding-top: 100px;
  .header {
    width: 100%;
    padding: 0 160px;
    box-sizing: border-box;
    margin-bottom: 40px;
    .item {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        width: 50%;
        display: flex;
        align-items: start;
        justify-content: start;
        .img {
          width: 100%;
        }
      }
      .right {
        width: 50%;
        display: flex;
        align-items: normal;
        justify-content: center;
        flex-direction: column;
        .right_head {
          margin-top: 20%;
          .title {
            color: #fff;
            font-size: calc(70px * var(--scale));
            font-weight: bold;
            text-align: left;
          }
          .texts {
            display: flex;
            align-items: center;
            margin-bottom: 30px;
            .text {
              color: #cccccd;
              font-size: calc(30px * var(--scale));
            }
            .shu {
              width: 1px;
              height: 30px;
              background-color: #4e4e51;
              margin: 0 10px;
            }
          }
          .btn {
            width: 230px;
            height: 80px;
            line-height: 80px;
            text-align: center;
            border-radius: 100px;
            color: #fff;
            font-size: calc(36px * var(--scale));
            background: linear-gradient(90deg, #8800ff 0%, #4000ff 100%);
            cursor: pointer;
          }
        }
      }
    }
    .right_bottom {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .infos {
        width: 120px;
        display: flex;
        align-items: center;
        flex-direction: column;
        border-radius: 20px;
        background: linear-gradient(to bottom, #020206 0%, #1b1b1e 95.71%);
        .img {
          width: 90px;
        }
        ::v-deep .el-image {
          overflow: none;
        }
        .text {
          color: #fff;
          font-size: calc(12px * var(--scale));
          margin: 10px 0;
        }
      }
    }
  }
  .nav {
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 30px;
    .nav_item {
      padding: 0 160px;
      box-sizing: border-box;
      .nav_item_title {
        font-size: calc(46px * var(--scale));
        font-weight: bold;
        color: #fff;
        text-align: center;
        margin-bottom: 4%;
      }
      .nav_item_title1 {
        color: #808082;
        font-size: calc(26px * var(--scale));
        text-align: center;
        margin-bottom: 1.5%;
      }
    }
    .nav_item1 {
      .nav_item_title {
        font-size: calc(46px * var(--scale));
        font-weight: bold;
        color: #fff;
        text-align: center;
        margin-bottom: 20px;
      }
      .nav_info {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding-top: 200px;
        padding-bottom: 300px;
        .img {
          width: 50%;
        }
        .list {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          .item {
            box-sizing: border-box;
            position: absolute;
            .item_bg {
              width: 100%;
              position: absolute;
              top: 0;
              left: 0;
            }
            .infos {
              padding: 20px;
              box-sizing: border-box;
            }
            .title {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              .text {
                font-size: calc(24px * var(--scale));
                color: #fff;
                margin-right: 20px;
              }
              .img1 {
                width: 60px;
              }
            }
            .text1 {
              color: #868688;
              font-size: calc(18px * var(--scale));
              margin-bottom: 10px;
              text-align: left;
            }
            .text2 {
              padding: 10px;
              border-radius: 10px;
              background-color: #363243;
              font-size: calc(18px * var(--scale));
              color: #d2bbff;
              text-align: left;
            }
          }
          .item0 {
            width: 20%;
            top: 15%;
            left: 10%;
            .infos {
              padding-right: 25px;
            }
          }
          .item1 {
            width: 30%;
            top: 8%;
            right: 3%;
            .infos {
              padding-left: 25px;
            }
          }
          .item2 {
            width: 26%;
            top: 57%;
            left: 3%;
          }
          .item3 {
            width: 20%;
            top: 75%;
            left: 38%;
          }
          .item4 {
            width: 24%;
            top: 60%;
            right: 3%;
          }
        }
      }
    }
    .nav_item2 {
      .tags {
        display: grid;
        grid-column-gap: 1.25rem;
        grid-template-rows: auto;
        grid-template-columns: repeat(6, 1fr);
        flex: 1;
        margin-bottom: 40px;
        .tag_item {
          .item {
            color: #6c6c6c;
            font-size: calc(20px * var(--scale));
            border-radius: 100px;
            background: #1f1f1f;
            padding: 10px 20px;
            position: relative;
            .img {
              width: 60px;
              position: absolute;
              top: -20px;
              right: -20px;
            }
          }
          .item1 {
            color: #fff;
            background: linear-gradient(to right, #8601fe 0%, #4000ff 100%);
          }
        }
      }
      .infos {
        width: 100%;
        min-height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        .left {
          width: 30%;
          border-top-left-radius: 40px;
          border-top-right-radius: 20px;
          border-bottom-left-radius: 20px;
          margin-right: 200px;
        }
        .right {
          width: 40%;
          display: flex;
          align-items: start;
          flex-direction: column;
          .text {
            font-size: calc(36px * var(--scale));
            background: linear-gradient(180deg, #ffffff 0%, #9655ff 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            color: transparent;
            display: inline-block;
            margin-bottom: 20px;
            text-align: left;
          }
          .text1 {
            color: #808385;
            font-size: calc(24px * var(--scale));
            white-space: pre-line;
            text-align: left;
          }
        }
      }
    }
    .nav_item3 {
      padding: 40px 160px;
      margin: 50px 0;
      background-color: #0f0f12;
      .item3_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 50px;
        position: relative;
        .item_head {
          color: #fff;
          font-size: calc(50px * var(--scale));
          font-weight: bold;
          position: absolute;
          top: 0;
          left: 0;
        }
        .item_left {
          width: 40%;
          .titles {
            display: flex;
            align-items: center;
            justify-content: start;
            margin-bottom: 30px;
            .title {
              font-size: calc(36px * var(--scale));
              font-weight: bold;
              background: linear-gradient(
                178.94deg,
                #ffffff 0.9%,
                #00b3ff 120.3%
              );
              -webkit-background-clip: text;
              background-clip: text;
              -webkit-text-fill-color: transparent;
              color: transparent;
              display: inline-block;
              margin-right: 10px;
            }
            .img {
              width: 100px;
              height: 40px;
            }
          }
          .texts {
            .text {
              font-size: calc(24px * var(--scale));
              color: #878788;
              text-align: left;
            }
          }
        }
        .item_right {
          width: 50%;
          .image_section {
            .img1 {
              width: 100%;
            }
          }
        }
      }
    }
    .nav_item4 {
      width: 100%;
      margin-bottom: 200px;
      .infos {
        display: flex;
        align-items: start;
        justify-content: space-between;
        position: relative;
        .info_left {
          width: 40%;
          .img {
            width: 100%;
          }
        }
        .info_right {
          width: 50%;
          .title {
            color: #fff;
            font-weight: bold;
            font-size: calc(50px * var(--scale));
            margin-bottom: 30px;
            text-align: left;
          }
          .item {
            margin-bottom: 30px;
            .text {
              width: 100%;
              font-size: calc(30px * var(--scale));
              font-weight: bold;
              background: linear-gradient(180deg, #ffffff 0%, #d06436 100%);
              -webkit-background-clip: text;
              background-clip: text;
              -webkit-text-fill-color: transparent;
              color: transparent;
              display: inline-block;
              margin-bottom: 20px;
              text-align: left;
            }
            .text1 {
              color: #888582;
              font-size: calc(24px * var(--scale));
              text-align: left;
            }
          }
        }
        .info_footer {
          width: 80%;
          padding: 20px 40px;
          position: absolute;
          background-image: url("https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/bottom_bg.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          bottom: -160px;
          left: 10%;
          .img {
            width: 100%;
            border-radius: 20px;
          }
          .footer_info {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 50px;
            .info_item {
              .info_head {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .text {
                  font-size: calc(30px * var(--scale));
                  font-weight: bold;
                  background: linear-gradient(180deg, #ffffff 0%, #d06436 100%);
                  -webkit-background-clip: text;
                  background-clip: text;
                  -webkit-text-fill-color: transparent;
                  color: transparent;
                  display: inline-block;
                  margin-right: 10px;
                }
                .img1 {
                  width: 100px;
                  height: 35px;
                }
              }
              .texts {
                color: #878787;
                font-size: calc(24px * var(--scale));
                text-align: left;
              }
            }
            .shu {
              width: 2px;
              height: 170px;
              background-color: #282828;
              // margin: 0 40px;
            }
          }
        }
      }
    }
    .nav_item5 {
      .line_infos {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .line_infos_item {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .head_img {
            width: 270px;
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
            .img {
              width: 100%;
              flex: none;
            }
          }

          .foot {
            width: 270px;
            height: 80px;
            display: flex;
            align-items: center;
            flex-direction: column;
            flex: none;

            .bg {
              width: 270px;
              height: 80px;
              flex: none;
            }
            .texts {
              flex: none;
              text-align: center;
              margin-top: -70px;
              z-index: 10;
              .text {
                font-size: calc(20px * var(--scale));
                color: #fff;
              }
              .text1 {
                font-size: calc(20px * var(--scale));
                color: #93a0ff;
              }
            }
          }
        }
      }
      .info_foot_text {
        font-size: calc(36px * var(--scale));
        font-weight: bold;
        background: linear-gradient(178.94deg, #ffffff 0.9%, #00b3ff 120.3%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        display: inline-block;
        margin-top: 30px;
        margin-bottom: 50px;
      }
    }
    .nav_item6 {
    }
    .nav_item7 {
      width: 100%;
      margin-bottom: 30px;
      .img {
        width: 100%;
      }
    }
  }
  .page_footer {
    width: 100%;
    padding: 30px;
    padding-left: 200px;
    padding-bottom: 100px;
    box-sizing: border-box;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    background-color: #0d0d11;
    display: flex;
    .img {
      width: 60%;
    }
  }
  .show {
    width: 500px;
    height: 420px;
    position: fixed;
    top: calc(50% - 210px);
    left: calc(50% - 250px);
    background-image: url("https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/product/show_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    z-index: 110;
    .show_bg {
      width: 100%;
      height: 100%;
    }
    .close {
      width: 30px;
      height: 30px;
      position: absolute;
      top: -30px;
      right: 0;
    }
    .show_head {
      display: flex;
      align-items: center;
      padding: 0 30px;
      .show_title {
        margin-top: 30px;
        font-size: calc(28px * var(--scale));
        font-weight: bold;
        background: linear-gradient(178.94deg, #ffffff 0.9%, #ca96fe 120.3%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        display: inline-block;
      }
    }
    .show_nav {
      margin-top: 50px;
      .ercode {
        width: 200px;
        height: 200px;
        margin-bottom: 20px;
        border-radius: 20px;
      }
      .texts {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .text {
          text-align: center;
          font-size: calc(16px * var(--scale));
          color: #817c83;
        }
      }
    }
  }
  .shade {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #000000a4;
    z-index: 100;
  }
}
.content1 {
  overflow: hidden;
  height: 100vh;
}
</style>
